import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("DocumentRevisionGetInput")
export class DocumentRevisionGetInput {
    @JsonProperty("mediaId", String, true)
    public mediaId: string = JsonPropertyEmpty;

    public constructor(args?: Partial<DocumentRevisionGetInput>) {
        Object.assign(this, args);
    }
}
